import "./content-window.scss";
import "./content-window.functions";

export default {
  /**
   * render channel iframe window
   * @param {*} channel
   * @param {*} btnSize
   * @returns
   */
  setWindow(channel, btnSize) {
    var channelWindow = "";

    if (channel.LoadAction == "iframe") {
      var dataChannel = `${channel["Channel"].ChannelName} - ${channel.Id}`;

      channelWindow = `
            <div data-channel="${dataChannel}" class="iframecontainer target iframeDown ${btnSize}">
                <div class="bar-loader"></div>

                <span 
                    class="closeIframe"
                    data-name="${channel["Channel"].ChannelName}"
                    data-id="${channel.Id}">
                    &times;
                </span>

                <iframe 
                    src="${contentWindow.preloadUrl(channel)}" 
                    height="495" 
                    width="363" 
                    frameborder="1"
                    allow="camera;microphone">
                </iframe>
            </div>
        `;
    }

    return channelWindow;
  },
};
